export default __webpack_public_path__ + "static/media/clem-onojeghuo-2.d16702ce.jpg";